module.exports = __webpack_public_path__ + "img/PD1505005778879250432.9fadf921.png";